export default "__VITE_ASSET__fZlvDXQB__"